import {
    FAVORITE_STYLE_SUCCESS,
    UNFAVORITE_STYLE_SUCCESS
} from '../../../core/js/actions/favoritesActions';

import { info } from '../../../core/js/utils/logger';

export function productFavoritesSubReducer(state = {}, action = {}) {
    switch (action.type) {
        case FAVORITE_STYLE_SUCCESS: {
            if (action.payload.styleNumber === state.styleNumber) {
                return Object.assign({}, state, {
                    favorited: true
                });
            }

            return state;
        }

        case UNFAVORITE_STYLE_SUCCESS: {
            if (action.payload.styleNumber === state.styleNumber) {
                return Object.assign({}, state, {
                    favorited: false
                });
            }

            return state;
        }

        default:
            return state;
    }
}
